import Card from '@zenbusiness/zui/Card';
import CardContent from '@zenbusiness/zui/CardContent';
import Heading from '@zenbusiness/zui/Heading';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const ReviewsCardRoot = superstyled({
  name: 'ReviewsCard',
  slot: 'Root',
  tag: Card,
  propsAdded: {
    variant: 'evelvation'
  },
  styles: ({ theme }) => ({
    borderRadius: theme.shape.rounded.lg,
    backgroundColor: theme.palette.background.grey.dark,

    [theme.breakpoints.up('lg')]: {
      borderRadius: theme.shape.rounded['2xl']
    }
  })
});

export const ReviewsCardStack = superstyled({
  name: 'ReviewsCard',
  slot: 'Stack',
  tag: Stack,
  styles: ({ theme }) => ({
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    '&:not(:only-child):not(:last-child)': {
      marginBlockEnd: theme.spacing(0.5)
    }
  })
});

export const ReviewsCardContent = superstyled({
  name: 'ReviewsCard',
  slot: 'Content',
  tag: CardContent,
  styles: ({ theme }) => ({
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(3)
    }
  })
});

export const ReviewsCardDescription = superstyled({
  name: 'ReviewsCard',
  slot: 'Description',
  tag: Text,
  propsAdded: {
    color: 'secondary',
    size: 'sm',
    weight: 'regular'
  }
});

export const ReviewsCardTitle = superstyled({
  name: 'ReviewsCard',
  slot: 'Title',
  tag: Heading,
  propsAdded: {
    component: 'h3',
    size: 'sm',
    weight: 'medium'
  }
});
